import React from 'react';
import { Link } from 'react-router-dom';
import { useGrid } from '../provider';
import AnchorColumnHeader from './anchor_column_header';
import Column from './column';
import DocumentModal from './document_modal';
import TitleColumn from './titleColumn';
const ComparisonGridTable = () => {
    const { anchorDoc, comparatorDocs, setModalDocument, setIsDocModalOpen, setDocBookmark, } = useGrid();
    return React.createElement(React.Fragment, null,
        React.createElement(DocumentModal, null),
        React.createElement("div", { className: 'comparison-grid', "data-testid": 'comparison-grid' },
            React.createElement("div", { className: 'left-anchor' },
                React.createElement(TitleColumn, { "data-testid": 'titles-column' }),
                React.createElement("div", { className: 'anchor-document', "data-testid": 'anchor-document-column' },
                    React.createElement(AnchorColumnHeader, null),
                    React.createElement("div", { className: 'scroll-space column' }),
                    React.createElement(Column, { doc: anchorDoc, columnId: 1 })),
                React.createElement("div", { className: 'right-container', "data-testid": 'documents-container' },
                    React.createElement("div", { className: 'headers' },
                        React.createElement("div", { name: 'scrollHeader', className: 'scroller syncscroll', "data-testid": 'document-headers' }, comparatorDocs.map((doc, index) => {
                            if (!Object.keys(doc.data).includes('clauses'))
                                return React.createElement(React.Fragment, null);
                            return (React.createElement("div", { key: `${doc.fileId}-header-cell`, className: 'column' },
                                React.createElement("div", { className: 'header cell', "data-testid": `cell-0-${index + 2}` },
                                    React.createElement("div", { className: 'file-name overflow-ellipsis', onClick: () => {
                                            setDocBookmark([]);
                                            setModalDocument(doc);
                                            setIsDocModalOpen(true);
                                        } }, doc.fileName),
                                    "\u00A0",
                                    React.createElement(Link, { target: '_blank', to: {
                                            pathname: `/document/${doc.fileId}`,
                                            search: '',
                                        }, className: 'title-text overflow-ellipsis', title: 'Open in New Tab' },
                                        React.createElement("i", { className: 'fas fa-external-link' })))));
                        }))),
                    React.createElement("div", { className: 'scroll-space syncscroll', name: 'scrollHeader' }, comparatorDocs.map(doc => (React.createElement("div", { key: `${doc.fileId}-phant`, className: 'phantom-column' })))),
                    React.createElement("div", { className: 'documents syncscroll', name: 'scrollHeader' }, comparatorDocs.map((doc, index) => {
                        if (!Object.keys(doc.data).includes('clauses'))
                            return React.createElement(React.Fragment, null);
                        const columnId = index + 2;
                        return (React.createElement(Column, { key: `${doc.fileId}-column-cells`, doc: doc, columnId: columnId }));
                    }))))));
};
export default ComparisonGridTable;
